import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import check from 'media/check-white.svg'
import { FormattedMessage } from 'react-intl'
import messages from './messages'

const translatedNames = {
  'About you': messages.aboutYou,
  Account: messages.account,
  Subscription: messages.subscription,
}

function ProgressIndicator({ current, done = false }) {
  const steps = {
    'About you': ['signUp.goal', 'signUp.gender', 'signUp.stats'],
    Account: [
      'signUp.pickAccountMethod',
      'signUp.emailAccountCreation',
      'signUp.setUp',
    ],
    Subscription: ['subscription'],
  }

  let currentStep

  if (!done) {
    for (let key in steps) {
      steps[key].forEach((view) => {
        if (current.matches(view)) {
          currentStep = key
        }
      })
      if (currentStep) break
    }

    if (!currentStep) return null
  }

  const stepClasses = [
    'c-progress-indicator--step-1',
    'c-progress-indicator--step-2',
    'c-progress-indicator--step-3',
  ]

  const currentStepIndex = Object.keys(steps).indexOf(currentStep)

  return (
    <div className="pt-20 text-center">
      <div
        className={classnames(
          'c-progress-indicator',
          done ? 'c-progress-indicator--step-4' : stepClasses[currentStepIndex],
        )}
      >
        <div className="c-progress-indicator__bar-empty" />
        <div className="c-progress-indicator__bar-filled" />
        <ol>
          {Object.keys(steps).map((step, i) => {
            return (
              <li
                key={step}
                className={classnames('c-progress-indicator__item relative', {
                  'c-progress-indicator__item--current': step === currentStep,
                  'c-progress-indicator__item--done':
                    i < currentStepIndex || done,
                })}
              >
                <div className="c-progress-indicator__item-bullet">
                  <img
                    className={classnames(
                      'mt-2',
                      i < currentStepIndex || done ? 'opacity-1' : 'opacity-0',
                    )}
                    src={check}
                    alt=""
                  />
                </div>
                <span className="c-progress-indicator__item-text">
                  <FormattedMessage {...translatedNames[step]} />
                  {step === currentStep && (
                    <span className="sr-only"> (current step)</span>
                  )}
                </span>
              </li>
            )
          })}
          <li
            className={classnames('c-progress-indicator__item', {
              'c-progress-indicator__item--done': done,
            })}
          >
            <div className="c-progress-indicator__item-bullet">
              <img
                className={classnames('mt-2', done ? 'opacity-1' : 'opacity-0')}
                src={check}
                alt=""
              />
            </div>
            <span className="c-progress-indicator__item-text">
              <FormattedMessage {...messages.done} />
              {done && <span className="sr-only"> (current step)</span>}
            </span>
          </li>
        </ol>
      </div>
    </div>
  )
}

ProgressIndicator.propTypes = {
  current: PropTypes.object,
  done: PropTypes.bool,
}

export default ProgressIndicator
